var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
			'btn',
      _vm.type ? `btn-${_vm.type}` : '',
      _vm.size ? `btn-${_vm.size}` : ''
    ],attrs:{"disabled":_vm.disabled || _vm.loading,"type":"button"},on:{"click":_vm.handleClick}},[(_vm.icon && !_vm.loading)?_c('span',{class:[`icon icon-${_vm.icon}`, _vm.$slots.default ? 'btn-icon' : '']}):_vm._e(),_vm._v(" "),(_vm.$slots.default && !_vm.loading)?_c('span',{staticClass:"btn-text"},[_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.loading)?_c('x-loading',{attrs:{"white":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }